import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { ELEMENT_TH } from '@udecode/plate';

// In-editor rendering for tables. Text formatting (bold, color, size) is carried by Slate marks and
// rendered by the default leaf components, so these only need to provide the table structure and
// preserve the per-cell background color that we read off pasted spreadsheet HTML.

export function TableElement({ attributes, children }) {
  return (
    <StyledTable {...attributes}>
      <tbody>{children}</tbody>
    </StyledTable>
  );
}

export function TableCellElement({ attributes, children, element = {} }) {
  const Cell = element.type === ELEMENT_TH ? StyledTh : StyledTd;
  const style = element.background ? { backgroundColor: element.background } : undefined;

  return (
    <Cell {...attributes} colSpan={element.colSpan} style={style}>
      {children}
    </Cell>
  );
}

TableElement.propTypes = {
  attributes: PropTypes.object,
  children: PropTypes.node,
};

TableCellElement.propTypes = {
  attributes: PropTypes.object,
  children: PropTypes.node,
  element: PropTypes.shape({
    type: PropTypes.string,
    background: PropTypes.string,
    colSpan: PropTypes.number,
  }),
};

const StyledTable = styled.table`
  border-collapse: collapse;
  margin: 4px 0;

  /* Wide tables scroll horizontally within themselves rather than stretching the editor. display:
   * block turns the table into a scroll container; width: max-content lets it size to its content
   * (capped at the editor width) so narrow tables aren't stretched. */
  display: block;
  max-width: 100%;
  overflow-x: auto;
  width: max-content;
`;

const cellStyles = css`
  border: 1px solid var(--color-default-border-color);
  padding: 4px 8px;
  vertical-align: top;
`;

const StyledTd = styled.td`
  ${cellStyles}
`;

const StyledTh = styled.th`
  ${cellStyles}
`;
